import React from "react";
import { cn } from "@/lib/cn";

const FIELD =
  "w-full rounded-[10px] bg-surface border border-edge px-3 py-2 text-sm text-ink " +
  "placeholder:text-ink-muted transition-colors " +
  "focus:outline-none focus:border-accent focus:ring-2 focus:ring-accent/25";

export const TextInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function TextInput({ className, ...rest }, ref) {
    return <input ref={ref} className={cn(FIELD, className)} {...rest} />;
  },
);

export const TextArea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function TextArea({ className, ...rest }, ref) {
    return <textarea ref={ref} className={cn(FIELD, "resize-none", className)} {...rest} />;
  },
);
